<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <hr class="mx-2">
      <li class="nav-item">
        <sidenav-item
          url="/users"
          :class="getRoute() === 'users' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Users'"
        >
          <template v-slot:icon>
            <i
              class="fa fa-user-o text-success text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/subscriptions"
          :class="getRoute() === 'subscriptions' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Subscriptions'"
        >
          <template v-slot:icon>
            <i
            class="fa fa-snapchat-ghost text-warning text-sm"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/new-admin"
          :class="getRoute() === 'new-admin' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الجداول' : 'Add Admin'"
        >
          <template v-slot:icon>
            <i
              class="fa fa-plus text-primary text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
        <sidenav-item
          url="/filter"
          :class="getRoute() === 'filter' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الاشتراك فلتر' : 'Filter Subscribtion'"
        >
          <template v-slot:icon>
            <i
              class="fa fa-plus text-primary text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <hr class="mx-3" />
      <li class="nav-item px-3 pt-1">
        <button  class="btn btn-outline-secondary border-0" @click="logout">
          <span> <i class="fa fa-sign-out text-info text-sm opacity-10"></i></span>
          <span>  Logout </span>
        </button>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>  
</template>
<script>  
import SidenavItem from "./SidenavItem.vue";
import AdminService from "../../views/service/AdminService";
import router from "../../router";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Jarvis",
      controls: "dashboard",
      isActive: "active",
      adminService : null
    };
  },
  created(){
    this.adminService = new AdminService();
  },
  components: {
    SidenavItem,
    // SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout(){
      this.adminService.logout().then((data) => {
        console.log(data);
        localStorage.removeItem('auth-token');
        this.$toast.add({
        severity: "success",
        summary: "successful",
        detail: "Logged Out",
        life: 3000,
      });
      router.push('/signin')

      });
    }
  }
};
</script>
